import { render } from "./GroupsDisplay.vue?vue&type=template&id=227288a6&ts=true&lang=pug"
import script from "./GroupsDisplay.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupsDisplay.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/GroupsDisplay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "227288a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('227288a6', __exports__)) {
    console.log('reload')
    api.reload('227288a6', __exports__)
  }
  
  module.hot.accept("./GroupsDisplay.vue?vue&type=template&id=227288a6&ts=true&lang=pug", () => {
    console.log('re-render')
    api.rerender('227288a6', render)
  })

}


export default __exports__